export default __webpack_public_path__ + "static/media/ipad-pro.2aca0754.png";